var React = require('react');

function FrontendDropdownMenuSegments (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M7 9v-8.938c-3.946 0.492-7 3.858-7 7.938 0 4.418 3.582 8 8 8 4.080 0 7.446-3.054 7.938-7h-8.938zM12.65 13.233c-1.281 1.14-2.933 1.767-4.65 1.767-0.945 0-1.862-0.185-2.724-0.55-0.833-0.352-1.582-0.857-2.225-1.501s-1.148-1.392-1.501-2.225c-0.365-0.862-0.55-1.779-0.55-2.724 0-1.717 0.628-3.368 1.767-4.65 0.873-0.982 1.994-1.691 3.233-2.060v8.71h8.71c-0.369 1.238-1.079 2.36-2.060 3.233zM8 0c4.418 0 8 3.582 8 8h-8v-8z"}));
}

FrontendDropdownMenuSegments.displayName = "FrontendDropdownMenuSegments";

FrontendDropdownMenuSegments.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendDropdownMenuSegments;

FrontendDropdownMenuSegments.default = FrontendDropdownMenuSegments;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-dropdown-menu-segments.svg
// module id = 1012
// module chunks = 0